



import { useEmitter } from '../../composition/useEmitter'
import { defineComponent } from '@vue/composition-api'
import { useAppContext } from '../../composition/useAppContext'
import { loadRemote } from '@module-federation/runtime'
import GlobalSettingsEvents from '../../../events/GlobalSettings'
let brandBoardGlobalSettingsModal: any = {}
let isMounted = false

export default defineComponent({
  mounted() {
    // Instead of mounting on component mount, listen for the brandboard event
    const emitter = useEmitter()
    // this.mountGlobalSettings()
    emitter.on(GlobalSettingsEvents.OPEN_GLOBAL_SETTINGS, this.mountGlobalSettings)
  },
  beforeDestroy() {
    // Remove the event listener
    const emitter = useEmitter()
    emitter.off(GlobalSettingsEvents.OPEN_GLOBAL_SETTINGS)
    
    if (brandBoardGlobalSettingsModal?.unmount) {
      brandBoardGlobalSettingsModal?.unmount()
      window['brandBoardGlobalSettingsModal'] = null
      isMounted = false
    }
  },
  methods: {
    async mountGlobalSettings() {
      if (isMounted) return
      if (brandBoardGlobalSettingsModal?.unmount) brandBoardGlobalSettingsModal?.unmount()
      try {
        const [createApp, Modal] = await Promise.all([
          loadRemote('brandBoardsApp/vue3').then((m: any) => m.createApp),
          loadRemote('brandBoardsApp/GlobalSettings').then((m: any) => m.default),
        ])
        
        const route = this.$route
        const router = this.$router
        const emitter = useEmitter()
        const storageLocale = localStorage.getItem('locale')
        const location = this.$route.params.location_id
        const { mountAppContext } = useAppContext()
        
        brandBoardGlobalSettingsModal = createApp(Modal, {
          route,
          router,
          emitter,
          location,
          locale: storageLocale || 'en'
        })
        mountAppContext({ brandBoardGlobalSettingsModal })
        brandBoardGlobalSettingsModal.mount(`#brandBoardGlobalSettings`)
        isMounted = true
      } catch(e) {
        console.error(e)
      }
    },
  },
})
